import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';

import { FullUser } from '@work4all/models/lib/Classes/FullUser.entity';

import { Panel } from '../../../../components/panel/Panel';
import { UpdateEntity } from '../../../../components/update-entity/UpdateEntity';
import { useMaskContext } from '../../../../hooks/mask-context';

import { ChangePasswordContent } from './components/ChangePasswordContent';
import { ResetMfaContent } from './components/ResetMfaContent';

export const SecurityTabPanel = () => {
  const { data } = useMaskContext<FullUser>();

  const { t } = useTranslation();

  return (
    <Panel>
      {!data.id && <UpdateEntity />}
      {data.id && (
        <>
          <Collapse defaultOpen title={t('COMMON.PASSWORD')}>
            <ChangePasswordContent />
          </Collapse>

          <Collapse defaultOpen title={t('COMMON.TWO_FACTOR_AUTHORIZATION')}>
            <ResetMfaContent />
          </Collapse>
        </>
      )}
    </Panel>
  );
};
